import React, { Component } from "react";
import ImageOrInitial from "./ImageOrInitial";

class RecentCard extends Component {
  constructor(props) {
    super(props);

    var url = "/";

    if(this.props.item.type === "BROKER"){
      url = "/brokers?id="+this.props.item.id;
    }
    else if(this.props.item.type === "ACCOUNT"){
      url = "/accounts?id="+this.props.item.id;
    }
    else if(this.props.item.type === "INSURER"){
      url = "/insurers?id="+this.props.item.id;
    }
    this.state = {
      url:url
    };
  }
  

  render() {
    if(!this.props.item.name) return null;
    
    return (
      <a className="card recentCard" href={this.state.url}>
        <ImageOrInitial image={this.props.item.imageUrl} name={this.props.item.name} className="rcIcon"/>

        <span className="rcTitle">{this.props.item.name}</span>
        <span>{this.props.item.type.toLowerCase()}</span>
      </a>
    );
  }
}
 
export default RecentCard;